@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.active-checkmark {
  color: @product-page--grid-row-checkmark--active--icon-color;
  width: 20px;
  height: 16px;
}
